import React, { useEffect } from "react";
import { Box } from "@mui/material";
import TopLayout from "./TopLayout";
import Sidebar from "./Sidebar";
import deviceStore from "../stores/DeviceStore";
import { Outlet } from "react-router-dom";

const Layout = () => {
  // useEffect(() => {
  //   console.log("Layout component mounted.");
  //   return () => {
  //     console.log("Layout component unmounted.");
  //   };
  // }, []);

  // console.log("Layout component rendered.");

  useEffect(() => {
    deviceStore.loadDevices();
  }, []);

  return (
    <Box sx={{ bgcolor: "background.default", color: "text.primary" }}>
      {/* Top Bar */}
      <TopLayout />

      {/* Sidebar and Main Content in horizontal flex */}
      <Box
        sx={{
          display: "flex",
          height: "calc(100vh - 90px)",
        }}
      >
        {/* Sidebar */}
        <Box
          sx={{
            position: "fixed",
            top: "88.5px",
            left: 0,
            width: 240,
            height: "calc(100vh - 90px)",
            zIndex: 1000,
            bgcolor: "background.default",
            borderRight: "1px solid",
            borderColor: "divider",
          }}
        >
          <Sidebar />
        </Box>

        {/* Main content */}
        <Box
          sx={{
            ml: "240px",
            width: "calc(100% - 240px)",
            p: 3,
            overflowY: "auto",
            height: "calc(100vh - 90px)",
            bgcolor: "background.default",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
